import Actions from "./actions";
var Creators = Actions.Creators;
var foodCategoryChange = Creators.foodCategoryChange;

var setFoodCategory = function setFoodCategory(foodCategory) {
  return function (dispatch, getState) {
    dispatch(foodCategoryChange(foodCategory));
  };
};

export default {
  setFoodCategory: setFoodCategory
};